interface WatermarkSettings {
    fillStyle: string;
    fontSize: number;
    font: string;
    textAlign: CanvasTextAlign;
    text: string;
}

interface WatermarkSettingsOptions {
    fillStyle?: string;
    fontSize?: number;
    font?: string;
    textAlign?: CanvasTextAlign;
    text?: string;
}

interface DownloadImageOptions {
    imageUrl: string;
    fileName: string;
    watermark?: boolean;
    watermarkSettings?: WatermarkSettingsOptions;
}

interface AddWatermarkOptions {
    canvas: HTMLCanvasElement;
    image: HTMLImageElement;
    settings: WatermarkSettings;
}

const defaultWatermarkSettings = {
    fillStyle: 'rgba(255, 255, 255, 0.1)',
    fontSize: 24,
    font: 'Arial',
    textAlign: 'center' as CanvasTextAlign,
    text: 'Mews',
};

const addWatermark = ({ canvas, image, settings }: AddWatermarkOptions) => {
    const context = canvas.getContext('2d');
    if (!context) return;

    // Set canvas size
    canvas.width = image.width;
    canvas.height = image.height;

    // Draw main image
    context.drawImage(image, 0, 0);

    // Create a small canvas for watermark
    const watermarkCanvas = document.createElement('canvas');
    const watermarkContext = watermarkCanvas.getContext('2d');

    // Set watermark size
    watermarkCanvas.width = 200;
    watermarkCanvas.height = 100;

    if (watermarkContext) {
        watermarkContext.font = `${settings.fontSize}px ${settings.font}`;
        watermarkContext.fillStyle = settings.fillStyle;
        watermarkContext.textAlign = settings.textAlign;
        watermarkContext.fillText(settings.text, 100, 50); // Centered text
    }

    // Create repeating pattern
    const pattern = context.createPattern(watermarkCanvas, 'repeat');
    if (pattern) {
        context.fillStyle = pattern;
        context.fillRect(0, 0, canvas.width, canvas.height);
    }
};

// Function to handle image download
export const downloadImage = ({
    imageUrl,
    fileName,
    watermark = false,
    watermarkSettings = defaultWatermarkSettings,
}: DownloadImageOptions) => {
    const canvas = document.createElement('canvas');
    if (!canvas) return;
    const watermarkSetting = { ...watermarkSettings, ...defaultWatermarkSettings };

    const image = new Image();
    // Avoid CORS issues
    image.crossOrigin = 'anonymous';
    image.src = imageUrl;

    image.onload = () => {
        if (watermark) {
            addWatermark({ canvas, image, settings: watermarkSetting });
        }
        // Convert to image and trigger download
        const link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = fileName;
        link.click();
    };
};
